export default __webpack_public_path__ + "static/media/img-0698-san-marino-half-face.e42e6bee.png";